// Which victory copy to show, by language.
//
// The same shape as `content/defeat`, and separate from it on purpose: the two
// endings share a *plate* and not a voice, and a single document branching on
// "did they win" would put the best sentence in the game and the worst one in
// the same paragraph for a translator to disentangle.
//
// It shares the rules' locale picker rather than growing a third one.

import type { ComponentType } from "react";
import type { MDXComponents } from "mdx/types";

/**
 * What the document is handed. Mirrored in `en.mdx`'s header comment.
 *
 * A `type` rather than an `interface`, and that is not a style choice: a
 * compiled `.mdx` module takes `MDXProps`, which is an index signature, and
 * only an object *type* gets the implicit index signature that makes it
 * assignable to one. As an interface this fails to compile with a message
 * about `string` that says nothing about MDX.
 *
 * No `reason`, unlike defeat: a run is lost three ways and won one.
 */
export type VictoryProps = {
  /** How far the run got. */
  stage: number;
};

export type VictoryDoc = ComponentType<VictoryProps & { components?: MDXComponents }>;

export const VICTORY_LOCALES: Record<string, () => Promise<{ default: VictoryDoc }>> = {
  en: () => import("./en.mdx")
};

/** The document for a locale code, falling back to English. */
export const victoryDoc = (code: string): (() => Promise<{ default: VictoryDoc }>) =>
  VICTORY_LOCALES[code] ?? VICTORY_LOCALES.en;
